'use client'

import { createContext, type ReactNode, use } from 'react'

interface RightDrawerContextValue {
  isOpen: boolean
  content: ReactNode | null
  openRightDrawer: (content: ReactNode) => void
  closeRightDrawer: () => void
}

export const RightDrawerContext = createContext<RightDrawerContextValue>({
  isOpen: false,
  content: null,
  openRightDrawer: () => {},
  closeRightDrawer: () => {},
})

export const useRightDrawerContext = () => {
  const context = use(RightDrawerContext)

  if (!context) {
    throw new Error('useRightDrawerContext must be used within a RightDrawerContext provider')
  }

  return context
}
